export default __webpack_public_path__ + "static/media/Broa-Branco.78c3a084.jpg";